module.exports = __webpack_public_path__ + "static/media/gts04.2e3eca0c.png";